import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const FredbyMediaBar = () => {
  return (
    <div
      data-testid="freddy-media-bar"
      className="fixed top-0 left-0 right-0 bg-[#060a28] border-b border-ff-border/50 z-[60]"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-9">
        <a
          href="https://freddymedia.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="freddy-media-logo"
          className="text-xs font-semibold tracking-widest uppercase text-ff-text-muted hover:text-ff-text transition-colors inline-flex items-center gap-1.5"
        >
          Freddy Media
          <ExternalLink size={9} />
        </a>

        <div className="flex items-center gap-1">
          <Link
            to="/"
            data-testid="media-nav-fiction"
            className="px-3 py-1.5 text-[11px] font-medium tracking-wide uppercase text-ff-text bg-ff-surface/60"
          >
            Fiction
          </Link>
          <a
            href="https://freddycompute.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="media-nav-compute"
            className="px-3 py-1.5 text-[11px] font-medium tracking-wide uppercase text-ff-text-muted hover:text-ff-text transition-colors inline-flex items-center gap-1"
          >
            Compute
            <ExternalLink size={9} />
          </a>
          <a
            href="https://www.freddymedia.com/newsletter"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="media-nav-news"
            className="px-3 py-1.5 text-[11px] font-medium tracking-wide uppercase text-ff-text-muted hover:text-ff-text transition-colors inline-flex items-center gap-1"
          >
            News
            <ExternalLink size={9} />
          </a>
          <a
            href="https://freddymedia.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="media-nav-media"
            className="px-3 py-1.5 text-[11px] font-medium tracking-wide uppercase text-ff-text-muted hover:text-ff-text transition-colors inline-flex items-center gap-1"
          >
            Media
            <ExternalLink size={9} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FredbyMediaBar;
